import React from 'react'
import loaderCSS from "../../styles/loader.module.scss";

const OverlayLoader = ({isOpen}) => {
    const modalClass = isOpen ? loaderCSS["open"] : loaderCSS["closed"];
    return (
        <div className={loaderCSS["loading-animation-modal-wrapper"]}>
            <div id={loaderCSS["LoadingAnimationModal"]} className={modalClass}>
                <div className={loaderCSS["content"]}>
                    <img src="/images/loading-animation.gif" alt="Loading..." loading="lazy" />
                </div>
            </div>
        </div>
    )
}

export default OverlayLoader;